module.exports = __webpack_public_path__ + "static/img/yytx35.d1a4e57.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx35.png
// module id = 813
// module chunks = 0